"use strict";
/* generated by gulpfile.js */
module.exports = exports = function () {
	return [
		"<input>",
		"applyClass",
		"autoApply",
		"autoUpdateInput",
		"buttonClasses",
		"cancelClass",
		"dateLimit",
		"drops",
		"endDate",
		"isInvalidDate",
		"linkedCalendars",
		"locale",
		"maxDate",
		"minDate",
		"opens",
		"parentEl",
		"ranges",
		"showDropdowns",
		"showWeekNumbers",
		"singleDatePicker",
		"startDate",
		"template",
		"timePicker",
		"timePicker24Hour",
		"timePickerIncrement",
		"timePickerSeconds",
		"timeZone"
];
};


/*****************
 ** WEBPACK FOOTER
 ** ./~/react-bootstrap-daterangepicker/lib/get-options.js
 ** module id = 809
 ** module chunks = 0
 **/